/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './arrow-bounce.css';

const ArrowDown = () => (
  <div className="arrow bounce">
    <a className="fa fa-chevron-down fa-2x arrow-down" href="#" />
  </div>
);

export default ArrowDown;
